/* Component Dependencies */
var detailsPageSingleHeroImageTemplate = require('templates/detailsPageSingleHeroImage.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');

AriesComponent.create({
  type: 'detailsPageSingleHeroImage',
  template: {
    'detailsPageSingleHeroImage': detailsPageSingleHeroImageTemplate
  },
  bindEvents: function () {
    this.registerPhotoGalleryPopup();
  },
  /**
  * This function registers Popup for the "view photo gallery" anchor
  */
  registerPhotoGalleryPopup : function() {
    var _self = this;
    var detailsPopup = new Popup({
        selector: '.tile-subpage-hero-image .mi-popover',
        sourceBlock: '.modal-content',
        fullScreen: true,
        mainClass: 'mi-gallery mi-gallery-full',
        alternateCloseMarkup: true
      });
      detailsPopup.register();
  }
});
